import './SearchResultsList.css';

import { useRef, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';

function SearchResultsList({
    children,
    isLoadingResults,
    searchResults,
    onClickCallback,
    getText,
    getSubText,
    topPosition = '43px', // default size of input field is 38px + 5px padding
    onClickOutside,
    show = false,
    onFooterClick = null,
    isTextBold = true,
}) {
    const { t } = useTranslation();
    const ref = useRef(null);

    const handleClick = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            onClickOutside && onClickOutside();
        }
    };

    useEffect(() => {
        // need timer otherwise, click that opens the search results list, closes it right away
        const timer = setTimeout(() => document.addEventListener('click', handleClick, true), 200);
        return () => {
            document.removeEventListener('click', handleClick, true);
            clearTimeout(timer);
        };
    }, [show]);

    if (!show) return null;

    return (
        <div ref={ref} className="results-list" style={{ top: topPosition }}>
            <Card>
                {isLoadingResults ? (
                    <Spinner animation="border" role="status" className="my-4 mx-auto">
                        <span className="visually-hidden">{t('loading_results_list')}</span>
                    </Spinner>
                ) : (
                    <ListGroup variant="flush">
                        {!searchResults || searchResults.length === 0 ? (
                            <ListGroup.Item>
                                <div className="result-item no-results">{t('no_results')}</div>
                            </ListGroup.Item>
                        ) : (
                            searchResults.map((result, i) => (
                                <ListGroup.Item
                                    action
                                    key={i}
                                    onClick={(event) => {
                                        event.preventDefault();
                                        if (onClickCallback) {
                                            onClickCallback(result);
                                        }
                                    }}
                                >
                                    <div className="result-item">
                                        <span className={isTextBold ? 'fw-bold' : ''}>
                                            {getText(result)}
                                        </span>
                                        {getSubText && getSubText(result) && (
                                            <span className="sub-text">({getSubText(result)})</span>
                                        )}
                                    </div>
                                </ListGroup.Item>
                            ))
                        )}
                    </ListGroup>
                )}
                {children && (
                    <Card.Footer
                        style={onFooterClick && { cursor: 'pointer' }}
                        onClick={onFooterClick}
                    >
                        {children}
                    </Card.Footer>
                )}
            </Card>
        </div>
    );
}

export default SearchResultsList;
